var lastCart = {};
var uuid = "";
var gfhaValue = 0;
var rateIndex;
var lastPricingData;
var waitingForPricingData = true;
var dependentOnPricingData = [];

function getValuesForType(data, type, isMonthly = true) {
    var values;
    if(data[isMonthly ? "monthly_fees" : "one_time_payments"].some(d => {
        values = d;
        return d.type === type;
    })) {
        return values;
    } else {
        return {};
    }
}

function track(event, rateIndex) {
    if(typeof dataLayer !== "undefined" && !orderProcessDisabled) {
        function trackCode() {
            var extraData = {};
            if(event === "add_to_cart") {
                var rateMonthly = getValuesForType(lastPricingData, "rate");
                var rateYearly = getValuesForType(lastPricingData, "rate", false);
                var data_source = sessionStorage.getItem("datasource");
                lastCart = {
                    "currency": "EUR",
                    "value": rateMonthly?.regular_price || 0,
                    "items": [
                        {
                            "item_name": (rateMonthly.name || rateYearly.name).split("<br>")[0],
                            "discount": rateMonthly?.rebate || 0,
                            "item_category": orderProcessType.toUpperCase(),
                            "item_category2": data_source === "CRM" ? "LEONET" : data_source.substring(0, 3),
                            "price": parseFloat((rateMonthly?.price || "0").replace(",", ".")),
                            "vermarktungsstatus": sessionStorage.getItem("bestatus"),
                            "standort": sessionStorage.getItem("plz") + " " + sessionStorage.getItem("ort"),
                            "strasse": sessionStorage.getItem("street") + " " + sessionStorage.getItem("housenumber"),
                            "item_variant": lastPricingData.promotion?.tracking_title || "",
                            "gfha_anschlusspreis": gfhaValue,
                            "anschlusspreis": parseFloat((rateYearly?.price || "0").replace(",", ".")),
                            "index": rateIndex
                        }
                    ]
                };
            } else if(event === "remove_from_cart") {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    "event": event,
                    "ecommerce": JSON.parse(sessionStorage.getItem("lastCart"))
                });
                return;
            } else if(event === "purchase") {
                lastCart["transaction_id"] = uuid;
                if(window.BorlabsCookie?.Consents?.hasConsent('google-ads')) {
                    var sha256=function a(b){function c(a,b){return a>>>b|a<<32-b}for(var d,e,f=Math.pow,g=f(2,32),h="length",i="",j=[],k=8*b[h],l=a.h=a.h||[],m=a.k=a.k||[],n=m[h],o={},p=2;64>n;p++)if(!o[p]){for(d=0;313>d;d+=p)o[d]=p;l[n]=f(p,.5)*g|0,m[n++]=f(p,1/3)*g|0}for(b+="\x80";b[h]%64-56;)b+="\x00";for(d=0;d<b[h];d++){if(e=b.charCodeAt(d),e>>8)return;j[d>>2]|=e<<(3-d)%4*8}for(j[j[h]]=k/g|0,j[j[h]]=k,e=0;e<j[h];){var q=j.slice(e,e+=16),r=l;for(l=l.slice(0,8),d=0;64>d;d++){var s=q[d-15],t=q[d-2],u=l[0],v=l[4],w=l[7]+(c(v,6)^c(v,11)^c(v,25))+(v&l[5]^~v&l[6])+m[d]+(q[d]=16>d?q[d]:q[d-16]+(c(s,7)^c(s,18)^s>>>3)+q[d-7]+(c(t,17)^c(t,19)^t>>>10)|0),x=(c(u,2)^c(u,13)^c(u,22))+(u&l[1]^u&l[2]^l[1]&l[2]);l=[w+x|0].concat(l),l[4]=l[4]+w|0}for(d=0;8>d;d++)l[d]=l[d]+r[d]|0}for(d=0;8>d;d++)for(e=3;e+1;e--){var y=l[d]>>8*e&255;i+=(16>y?0:"")+y.toString(16)}return i};
                    extraData.user_data = {
                        sha256_email_address: sha256(jQuery("#email").val().trim().toLowerCase())
                    }
                }
            }
            var routerMonthly = getValuesForType(lastPricingData, "router")?.price || "";
            var routerYearly = getValuesForType(lastPricingData, "router", false)?.price || "";
            if(routerMonthly !== "" || routerYearly !== "") {
                var monatliche_kosten_router = routerMonthly !== "" ? parseFloat(routerMonthly.replace(",", ".")) : "0";
                lastCart.items[0]["monatliche_kosten_router"] = monatliche_kosten_router;
                lastCart.items[0]["item_brand"] = jQuery('input[type="radio"][name="cost"]:checked').closest(".product").find(".product-title").text();
            } else {
                delete lastCart.items[0]["monatliche_kosten_router"];
                delete lastCart.items[0]["item_brand"];
            }
            lastCart.items[0]["einmalige_kosten"] = parseFloat(lastPricingData.one_time_payment.replace(",", "."));
            if(event === "add_to_cart") {
                sessionStorage.setItem("lastCart", JSON.stringify(lastCart));
            }
            dataLayer.push({ ecommerce: null });
            dataLayer.push(Object.assign({
                "event": event,
                "ecommerce": lastCart
            }, extraData));
        }
        if(waitingForPricingData) {
            dependentOnPricingData.push(trackCode);
        } else {
            trackCode();
        }
    }
}
performance.getEntriesByType("navigation").forEach(entry => {
    if (entry.type === "reload") {
        uuid = sessionStorage.getItem("transactionUuid");
    }
});
if(typeof uuid !== "string" || uuid.length === 0) {
    uuid = crypto.randomUUID();
    sessionStorage.setItem("transactionUuid", uuid);
} else {
    lastCart = JSON.parse(sessionStorage.getItem("lastCart") || "{}");
    if(sessionStorage.getItem("addedCart") === "1") {
        track("remove_from_cart");
    }
}
(function($) {
    $(function() {
        // extra data for price calculation
        window.sendExtra = {};

        $(".rate-toggle > a").on("click", function () {
            $(".tarif-bersicht-nd").show();
            equalRateDataHeight();
            var b = $('.js-rate[data-articleid="' + sessionStorage.getItem("rateMoniker") + '"]');
            var rcnd = b.closest(".rates-container-nd")[0];
            adjustScrollButtons(rcnd);
            b.length ? rcnd.scrollLeft = -(b[0].offsetLeft - rcnd.clientWidth / 2 + b[0].clientWidth / 2) : 0;
            adjustScrollButtons(rcnd);
            $(".rate-toggle, #preSelectedRate").remove();
            $(".preSelectedRate-shown").removeClass("preSelectedRate-shown");
            $("html, body").animate({"scrollTop": 0}, 0);
        });

        var maxBirthdate = new Date().toISOString().split("T")[0].split("-");
        maxBirthdate[0] = (+maxBirthdate[0] - 18) + "";
        if(maxBirthdate[2] === "29" && maxBirthdate[1] === "02" ) {
            maxBirthdate[2] = "28";
        }
        $('input[name="birthdate"]').prop("max", maxBirthdate.join("-"));

        $("#wtd").prop("min", new Date(new Date().getTime() + 28 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]).prop("max", new Date(new Date().getTime() + 90 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]).on("change", function() {
            $("#radWt2").val(this.value);
        });

        $('input[type="date"][max]').on("change", function() {
            if(new Date(this.value).getTime() > new Date(this.max).getTime()) {
                setNote(this.closest(".input-container"), "tooyoung", true);
            } else {
                setNote(this.closest(".input-container"), "tooyoung", false);
            }
        });
        $('input[type="date"][min]').on("change", function() {
            if(new Date(this.value).getTime() < new Date(this.min).getTime()) {
                setNote(this.closest(".input-container"), "tooold", true);
            } else {
                setNote(this.closest(".input-container"), "tooold", false);
            }
        });

        // helper
        function setNote(onElement, note, toOn) {
            onElement = $(onElement);
            var content = (onElement.attr("data-note") || "").replace(note, "").replace(/  /, " ").trim();
            if(toOn || content.length) {
                onElement.attr("data-note", (toOn ? note + (content.length ? " " : "") : "") + content);
            } else {
                onElement.removeAttr("data-note");
            }
        }

        // get prices to show
        var lastHandledCounter = -1;
        var requestCounter = 0;

        var rebateValue = "";
        var originalRebateValue = "";
        var $rebate = $("#rebate");
        var $rebateActivateButton = $("#rebateActivate");
        var rebateProductID = sessionStorage.getItem("rebateProductID");
        if(rebateProductID) {
            sendExtra[rebateProductID] = 1;
        }

        var updateCount = 0;
        var doTrack = false;            // enable to let updatePricing call tracking, uses updateCount to differentiate first add to cart from later ones

        window.updatePricing = function (doreturn) {
            if(orderProcessDisabled) {
                return;
            }
            var urlcomponents = {};
            var send = {
                "rebate": rebateValue,
                "fttb-status": sessionStorage.getItem("bestatus") ?? "",
                "foreign_id": sessionStorage.getItem("foreignid"),
            };
            if(orderProcessType !== "b2b") {
                if ($("#radio-newphone").is(":checked")) {
                    send["paid-phone-number"] = parseInt("0" + $("#paidphonenumbers").val(), 10);       // default val can be no number, parse 0 + results in 0 then
                } else {
                    var countExtraPortphones = $("#furtherPhonestoport .furtherphonetport").length - 2;
                    send["paid-phone-number"] = countExtraPortphones >= 0 ? countExtraPortphones : 0;
                }
            }
            send = Object.assign(send, sendExtra);
            Array.prototype.forEach.call(document.querySelectorAll('[data-producttype]:not([data-amount="0"])'), function(e) {
                switch(e.dataset.producttype) {
                    case "product_id":
                        send[e.dataset.articleid] = parseInt(e.getAttribute("data-amount"), 10);
                        break;
                    case "router_product":
                        send["router"] = {
                            "product": e.dataset.articleid,
                            "paymentType": {
                                "monthly_fee": "lease",
                                "none": "none",
                                "one_time_payment": "buy"
                            }[e.querySelector("input:checked").value]
                        };
                        // no break !
                    case "rate":
                        urlcomponents[e.dataset.producttype] = e.dataset.articleid;
                        break;
                    default:
                }
            });
            if(doreturn === true) {
                return {
                    rate: urlcomponents.rate,
                    router: urlcomponents.router_product,
                    products: send,
                    customer_name: (
                        orderProcessType === "b2b"
                            ? $("#personal-company").val()
                            : ($("#personal-name").val() + " " + $("#personal-surname").val())
                    )
                };
            } else {
                if(typeof urlcomponents.rate !== "undefined") {
                    waitingForPricingData = true;
                    $.post({
                        url: "/wp-json/leo/v1/checkout/calculate/" + encodeURIComponent(urlcomponents.rate),
                        data: JSON.stringify(send),
                        success: (function(requestId, rateIndex) {
                            return function(data) {
                                if(data.data && data.data.status) {
                                    if(confirm("Es ist ein Fehler bei der Preisbestimmung aufgetreten.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                        location.href = "#Kontakt";
                                    }
                                } else {
                                    if(requestId > lastHandledCounter) {
                                        lastHandledCounter = requestId;
                                        var $chosenRate = $(".js-rate[chosenone]");
                                        var $rateName = $chosenRate.find(".rate-name-nd").clone();
                                        $rateName.find(".rate-top-seller-text-nd").remove();
                                        var rateName = $rateName.html();
                                        $(".js-summary-rate-name").html(rateName);
                                        $step3OverviewProducts.find(".js-summary-rate-name").html(rateName);
                                        $(".js-summary-downstream").text($chosenRate.find(".downstream-feature").text());
                                        $(".js-summary-upstream").text($chosenRate.find(".upstream-feature").text());
                                        show($(".js-summary-rate-features"));
                                        var mFees = "";
                                        data.monthly_fees.forEach(function(e) {
                                            mFees += "<tr><th>" + e.name + "</th><td>" + e.price + "&#8239;€</td></tr>";
                                        });
                                        mFees += "<tr><th>" + data.monthly_fee_label + "</th><td><strong>" + data.monthly_fee + "&#8239;€</strong></td></tr>";
                                        var oFees = "";
                                        data.one_time_payments.forEach(function(e) {
                                            oFees += "<tr><th>" + e.name + "</th><td>" + e.price + "&#8239;€</td></tr>";
                                        });
                                        oFees += "<tr><th><strong>" + data.one_time_payment_label + "</strong></th><td><strong>" + data.one_time_payment + "&#8239;€</strong></td></tr>";
                                        $(".js-monthly-fees").html(mFees);
                                        $(".js-onetime-payments").html(oFees);
                                        var rval = $rebate.val();
                                        if(rval !== "" && typeof $rebate.closest(".input-container").attr("wrong") === "undefined") {
                                            $rebateActivateButton.attr("activationsuccess", "").removeClass("disabled");
                                        } else {
                                            $rebateActivateButton.removeAttr("activationsuccess");
                                            $rebate.removeClass("disabled");
                                            $rebate.val().length ? $rebateActivateButton.removeClass("disabled") : $rebateActivateButton.addClass("disabled");
                                        }
                                        show($(".summary"));
                                        lastPricingData = data;
                                        waitingForPricingData = !send["router"];
                                        while(dependentOnPricingData.length) {
                                            dependentOnPricingData.shift()();
                                        }
                                        if(doTrack) {
                                            doTrack = false;
                                            if(updateCount > 0) {
                                                track("remove_from_cart");
                                            }
                                            sessionStorage.setItem("addedCart", "0");
                                            track("add_to_cart", rateIndex);
                                            sessionStorage.setItem("addedCart", "1");
                                            ++updateCount;
                                        }
                                    }
                                }
                            };
                        })(++requestCounter, rateIndex),
                        error: function(data) {
                            if(data.responseJSON?.code === 1709301526) {
                                $rebateActivateButton.removeAttr("activationsuccess").removeClass("disabled");
                                $rebate.removeClass("disabled").closest(".input-container").attr("wrong", "nomatch").find(".addressplacement").html(sessionStorage.getItem("street") + " " + sessionStorage.getItem("housenumber") + "<br>" + sessionStorage.getItem("plzort") + sessionStorage.getItem("district"));
                                if(rebateValue !== originalRebateValue) {
                                    rebateValue = originalRebateValue;
                                    setTimeout(updatePricing, 1);
                                    return;
                                } else if(rebateValue !== "") {
                                    rebateValue = "";
                                    setTimeout(updatePricing, 1);
                                    return;
                                }
                            } else if(data.responseJSON && [4598347625, 5766683442, 5837649534].includes(data.responseJSON.code)) {
                                $rebateActivateButton.removeAttr("activationsuccess").removeClass("disabled");
                                $rebate.removeClass("disabled").closest(".input-container").attr("wrong", "");
                                if(rebateValue !== originalRebateValue) {
                                    rebateValue = originalRebateValue;
                                    setTimeout(updatePricing, 1);
                                    return;
                                } else if(rebateValue !== "") {
                                    rebateValue = "";
                                    setTimeout(updatePricing, 1);
                                    return;
                                }
                            }
                            if(confirm("Es ist ein Fehler bei der Preisbestimmung aufgetreten.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen")) {
                                location.href = "#Kontakt";
                            }
                        }
                    });
                }
            }
        }
        
        var chosenRate;

        // input handler
        var doscroll = false;
        Array.prototype.forEach.call(document.querySelectorAll("[data-amount]"), function(e) {
            Array.prototype.forEach.call(e.querySelectorAll(".js-choose"), function(f) {
                if($(f).closest("[data-amount]").get(0) === e) {
                    f.addEventListener("click", function() {
                        switch(f.type) {
                            case "button":
                                chosenRate = e;
                                var chosenone = document.querySelector(".tarif-bersicht-nd [chosenone]");                              // knowing button is part of rates
                                if(chosenone) {
                                    chosenone.removeAttribute("chosenone");
                                    chosenone.dataset.amount = "0";
                                }
                                chosenRate.setAttribute("chosenone", "");
                                chosenRate.dataset.amount = "1";
                                var articleId = chosenRate.dataset.articleid;
                                document.body.setAttribute("data-israte", articleId);
                                document.body.setAttribute("data-chosenratetype", chosenRate.dataset.type);
                                if(articleId === "b2c30" || articleId === "b2c10") {
                                    $("#funOptionen30").show();
                                    $("#funOptionen").hide();
                                } else {
                                    $("#funOptionen").show();
                                    $("#funOptionen30").hide();
                                }
                                // adjust free router
                                if($('.product:not([freefor~="'+articleId+'"]) .when-freeforrate input[type=radio]:checked').length) {
                                    $("#routerInput0")[0].click();
                                }
                                if($('.product[freefor~="'+articleId+'"] .when-notfreeforrate input[type=radio]:checked').length) {
                                    $("#routerInput0")[0].click();
                                }
                                // remove all free products
                                $('[freefor] input[type=checkbox]').each(function() {                               // check for :checked in each
                                    if($(this).is(":checked")) {                                                    // check for :checked because dependencies can be stacked and event handler are run immediately before next array element/jQ object which was already found and if that is part of stack would get clicked twice
                                        this.click();
                                    }
                                });
                                $('[freefor].isThatRate').removeClass("isThatRate");
                                // add free product if available
                                $('[freefor~="'+articleId+'"] input[type=checkbox]').each(function() {              // check for :not(:checked) in each
                                    if(!$(this).is(":checked")) {                                                   // check for :checked because dependencies can be stacked and event handler are run immediately before next array element/jQ object which was already found and if that is part of stack would get clicked twice
                                        this.click();
                                    }
                                });
                                $('[freefor~="'+articleId+'"]').addClass("isThatRate");
                                if(["b2c300", "b2c500", "b2c1000"].includes(articleId)) {
                                    $(".js-summary-wechselgarantie").show();
                                } else {
                                    $(".js-summary-wechselgarantie").hide();
                                }
                                hide($("#initialButton"));
                                show($("#nextButton"));
                                hide($("#initialButton1"));
                                show($("#nextButton1"));
                                originalRebateValue = chosenRate.getAttribute("data-rebatecode");
                                rebateValue = originalRebateValue;
                                $rebate.val("").closest(".input-container").removeAttr("wrong");
                                $(".rebated").empty();
                                var rebatedproducts = JSON.parse(chosenRate.dataset.rebatedproducts || "{}");
                                for(var product in rebatedproducts) {
                                    var price = rebatedproducts[product];
                                    if(Array.isArray(price)) {
                                        if(price[0] !== -1) {
                                            $('[data-articleid="' + product + '"] .product-cost.monthly-cost .rebated').text(new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price[0]) + " € mtl. Miete in den ersten " + price[2] + " Monaten, danach " + new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price[3]) + " € mtl.");
                                        }
                                        if(price[1] !== -1) {
                                            $('[data-articleid="' + product + '"] .product-cost.one-time-payment .rebated').text(new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price[1]) + " €");
                                        }
                                    } else {
                                        $('[data-articleid="' + product + '"] .product-cost .rebated').text(new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price) + " € monatlich");
                                    }
                                }
                                hide($(".homeid-or-gfha"));
                                hide($step3Overview.find(".homeid-or-gfha"));
                                $(".wunschtermin").removeClass("deactivated");
                                $step3Overview.find(".wunschtermin").removeClass("deactivated");
                                if(chosenRate.getAttribute("data-type") === "ftth") {
                                    if(sessionStorage.getItem("status") !== "nvm tif") {
                                        $(".wunschtermin").addClass("deactivated");
                                        $step3Overview.find(".wunschtermin").addClass("deactivated");
                                    }
                                    if(sessionStorage.getItem("geeprocess") === "true") {
                                        show($(".gfha-possible"));
                                        show($step3Overview.find(".gfha-possible"));
                                        gfhaValue = sessionStorage.getItem("gfhacosts");
                                        showIgnoreSubs($(".homeid-or-gfha"));
                                        showIgnoreSubs($step3Overview.find(".homeid-or-gfha"));
                                    } else {
                                        hide($(".gfha-possible"));
                                        hide($step3Overview.find(".gfha-possible"));
                                        let homeid = JSON.parse(sessionStorage.getItem("homeid") || "[]");
                                        if(homeid.length === 1 || (homeid.length > 1 && !(sessionStorage.getItem("datasource") === "UGG" && sessionStorage.getItem("nga") !== "UGGLAS"))) {
                                            showIgnoreSubs($(".homeid-or-gfha"));
                                            showIgnoreSubs($step3Overview.find(".homeid-or-gfha"));
                                        }
                                    }
                                }
                                if(doscroll) {
                                    $("html, body").animate({"scrollTop": $("#productsAndSummary").offset().top}, 2000);
                                } else {
                                    doscroll = true;
                                }
                                doTrack = true;
                                break;
                            case "radio":
                                $(e).closest("[type=radios]").find("[data-amount]").attr("data-amount", "0");
                                e.dataset.amount = f.value;
                                break;
                            case "checkbox":
                                e.setAttribute("data-amount", f.checked ? "1" : "0");
                                break;
                        }
                        setTimeout(updatePricing, 1);       // allow other handlers to intefere and adjust values
                    });
                }
            });
        });

        var baseHref = location.href.split("#")[0].replace(/\/+$/, "");

        var step2urlMapping = [
            "tarifauswahl",
            "dateneingabe",
            "bestellung"
        ];

        $(document).ready(() => {           // wait for main JS to get requested and executed, it provides required functions, and it contains code which must run before the click gets executed potentially resulting in change of the hash
            // remove what used to be not delivered by backend on a cookie
            $(".js-rate.rate-availability-not-given").remove();
            adjustScrollButtons($(".tarif-bersicht-nd .rates-container-nd").get(0));

            // remove HTML which cannot be used during this session
            var datasource = sessionStorage.getItem("datasource");
            $('[data-only-keep-if-source]:not([data-only-keep-if-source~="' + datasource + '"])').remove();
            $step3Overview.find('[data-only-keep-if-source]:not([data-only-keep-if-source~="' + datasource + '"])').remove();
            
            // evaluate chosen rate
            if(location.hash.length < 2) {
                var rateMoniker = sessionStorage.getItem("rateMoniker");
            } else {
                var rateMoniker = location.hash.substr(location.hash.indexOf("-") + 1);
                sessionStorage.setItem("rateMoniker", rateMoniker);
            }
            var $chosenRate = $('.js-rate[data-articleid="' + rateMoniker + '"]');
            var $rateName = $chosenRate.find(".rate-name-nd").clone();
            $rateName.find(".rate-top-seller-text-nd").remove();
            $("#selectedRate").html($rateName.html());

            $(".js-rate").each(function(i) {
                this.dataset.index = "" + (i + 1);
            });

            rateIndex = parseInt(sessionStorage.getItem("rateIndex") || "0", 10);
            if(rateIndex === 0) {
                performance.getEntriesByType("navigation").forEach(entry => {
                    if (entry.type === "reload") {
                        rateIndex = parseInt(sessionStorage.getItem("setIndex") || "0", 10);
                    }
                });
            }
            sessionStorage.setItem("setIndex", "" + rateIndex);
            sessionStorage.removeItem("rateIndex");

            function changeIndex(event) {
                if(event.originalEvent.isTrusted) {
                    rateIndex = - $(this).closest(".js-rate").data("index");
                    sessionStorage.setItem("setIndex", "" + rateIndex);
                }
            }
            $(".js-order-change-rate").on("click", changeIndex);

            $('#products .rate-toggle a, #check0, #checkRSAD, #checkPORT, #check3, #check2').on('keydown', function(e) {
                if(e.key === 'Enter') {
                    this.click();
                }
            });

            // prefill data from availability check
            if(sessionStorage.getItem("availabilitychecked") === "true") {
                document.body.dataset.key = sessionStorage.getItem("key");
                
                var street = $("#personal-street").val(sessionStorage.getItem("street")).data("original", sessionStorage.getItem("street")).trigger("input").attr("disabled", "");
                var housenumber = $("#personal-housenumber").val(sessionStorage.getItem("housenumber")).data("original", sessionStorage.getItem("housenumber")).trigger("input").attr("disabled", "");
                var plz = $("#personal-postalcode").val(sessionStorage.getItem("plz")).data("original", sessionStorage.getItem("plz")).trigger("input").attr("disabled", "");
                var ort = $("#personal-city").val(sessionStorage.getItem("ort")).data("original", sessionStorage.getItem("ort")).trigger("input").attr("disabled", "");
                setTimeout(() => ort.val(sessionStorage.getItem("ort") + sessionStorage.getItem("district")).data("usedata", true), 1000);

                $("body").addClass("availability-given");
            } else {
                alert("Wir haben die Daten zu Ihrer Verfügbarkeitsabfrage nicht laden können.\n\nBitte führen Sie vor Bestellung eine Verfügbarkeitsabfrage aus\nund leeren Sie nicht Browser-Daten während Ihres Besuches auf leonet.de.\n\nWir leiten Sie nun auf die Startseite.");
                location.href = "/";
            }

            $('[data-dynid="companyname"]').text(sessionStorage.getItem("companyname"));

            try {
                var homeid = JSON.parse(sessionStorage.getItem("homeid") || "[]");
                if(homeid.length) {
                    if(homeid.length === 1) {
                        $(".homeid-entry .js-dropdown-display").html(homeid[0]);
                        $(".homeid-entry .js-dropdown-items").addClass("disabled").prop("value", homeid[0]);
                    } else {
                        var $home_iddd = $(".homeid-entry .js-dropdown-items-container");
                        var $option = $('<div class="dropdown-item js-dropdown-item" data-val="" tabindex="-1" role="option"></div>');
                        homeid.forEach(hid => {
                            var $optionClone = $option.clone(true);
                            $optionClone.html(hid);
                            $optionClone.attr("data-val", hid);
                            $optionClone.on("click", window.selectDropdownItem);
                            $home_iddd.append($optionClone);
                        });
                    }
                    show($(".homeid-entry"));
                    // showing parent is done in rate (click) evaluator
                }
            } catch(e) { }

            $chosenRate.length ? $chosenRate.closest(".rates-container-nd")[0].scrollLeft = -$chosenRate[0].offsetLeft : 0;
            var c = $chosenRate.find(".js-choose");
            if(c.length) {
                c[0].click();               // jQuery does not trigger events on buttons
            }

            history.replaceState({handleAsStep: true}, "", baseHref + "/" + step2urlMapping[0]);

            function sonstige(e, d) {
                if (d === "unbekannt") {
                    $("#phonesServiceProviderOtherContainer").removeAttr("hidden");
                    $("#phonesServiceProviderOtherContainer").attr("required", true);
                    $("#phonesServiceProviderOtherContainer").css("display", "block");
                } else {
                    $("#phonesServiceProviderOtherContainer").attr("hidden", true);
                    $("#phonesServiceProviderOtherContainer").css("display", "none");
                    $("#phonesServiceProviderOtherContainer").removeAttr("required");
                    $("#phonesServiceProviderOther").val('');
                }
            }
            $('#phonesServiceProvider').on("pickedup", sonstige);

            $(".js-cart-link").on("click", function() {
                scrollTo({
                    left: 0,
                    top: $('fieldset[data-step="' + $("[data-currentstep]").attr("data-currentstep") + '"] .summary').offset().top,
                    behavior: "smooth"
                });
            });

            if(!orderProcessDisabled) {
                document.getElementById("orderprocessDisabledLayer")?.removeAttribute("id");
            }
        });

        $rebateActivateButton.on("click", function() {
            if($rebateActivateButton.attr("activationsuccess") === "") {
                rebateValue = originalRebateValue;
                $rebate.val("");
                $rebate.closest(".input-container").removeAttr("wrong");
            } else {
                rebateValue = $rebate.val();
            }
            $rebate.addClass("disabled");
            $rebateActivateButton.addClass("disabled");
            updatePricing();
        });
        $rebate.on("input", function() {
            $rebate.closest(".input-container").removeAttr("wrong");
            this.value.length ? $rebateActivateButton.removeClass("disabled") : $rebateActivateButton.addClass("disabled");
        });
        
        // special note handling
        window.selectFirstRouter = function() {
            $("#routerInput0").click();                
            hide($('#warning'));
            $("#routerInput0").trigger("focus");
        };
    
        function openWarningLayer() {
            show($('#warning'), true);
        }

        $(".router2 label").on("click", openWarningLayer);

        $('.router2 input').on('keydown', function(e) {
            if(e.key === 'Enter') {
                openWarningLayer();
            }
        });

        $('#warning').find('.leo-router ').trigger('focus');

        //input handling
        function inform() {
            this.setAttribute("data-val", this.value.replace("'", "&#39;"));
        }
        $("input[type=text], input[type=email], input[type=date], input[type=tel], input[type=number]").on("input", inform);

        function makeAvailable(e, d) {
            this.value = d.replace("'", "&#39;");
        }
        $("[type=dropdown]").on("pickedup", makeAvailable);
        
        $("#paidphonenumbers").on("pickedup", updatePricing);
        $("[name=portphone]").on("change", updatePricing);

        function setToDefault(selectorElementAbove) {
            var selectorToFind = selectorElementAbove + " input[type=checkbox]";                // only checkbox supported yet
            $(selectorToFind).add($step3Overview.find(selectorToFind)).each(function() {        // check for :checked in each
                var $this = $(this);
                if($this.is(":checked") !== ($this.attr("default") === "true")) {               // check for :checked because dependencies can be stacked and event handler are run immediately before next array element/jQ object which was already found and if that is part of stack would get clicked twice
                    this.click();                                                               // proxy triggers updatePricing() (and everything else associated)
                }
            });
        }
        function toggleElement(e) {
            var selectorElementToToggle = $(this).attr("toggles");
            var $elementToToggle = $(selectorElementToToggle);
            toggle($elementToToggle);
            toggle($step3Overview.find(selectorElementToToggle));
            if(!$elementToToggle.is(":checked")) {
                setToDefault(selectorElementToToggle);
            }
            e.stopPropagation();
        }
        function showElement(e) {
            var selectorElementToShow = $(this).attr("shows");
            $(selectorElementToShow).addClass("shown");
            $step3Overview.find(selectorElementToShow).addClass("shown");
            e.stopPropagation();
        }
        function hideElement(e) {
            var selectorElementToHide = $(this).attr("hides");
            $(selectorElementToHide).removeClass("shown");
            $step3Overview.find(selectorElementToHide).removeClass("shown");
            setToDefault(selectorElementToHide)
            e.stopPropagation();
        }
        $("[toggles]").on("click", toggleElement)
        $("[shows]").on("click", showElement);
        $("[hides]").on("click", hideElement);

        $('[name="fun_settop_box"]').on("click", function() {
            $(this).closest("[data-amount]").attr("data-amount", this.checked ? $("#amount_settop_box").attr("value") : "0");
        });
        $("#amount_settop_box").on("pickedup", function(e, d) {
            $('[name="fun_settop_box"]').is(":checked") ? $(this).closest("[data-amount]").attr("data-amount", d) : "0";
            updatePricing();
        });

        $('[name="zusatzsprachkanaele"]').on("click", function() {
            $(this).closest("[data-amount]").attr("data-amount", this.checked ? $("#amount_zusatzsprachkanaele").attr("value") : "0");
        });
        $("#amount_zusatzsprachkanaele").on("pickedup", function(e, d) {
            $('[name="zusatzsprachkanaele"]').is(":checked") ? $(this).closest("[data-amount]").attr("data-amount", d) : "0";
            updatePricing();
        });

        $('[name="weiteredurchwahlnummern"]').on("click", function() {
            $(this).closest("[data-amount]").attr("data-amount", this.checked ? $("#amount_weiteredurchwahlnummern").attr("value") : "0");
        });
        $("#amount_weiteredurchwahlnummern").on("pickedup", function(e, d) {
            $('[name="weiteredurchwahlnummern"]').is(":checked") ? $(this).closest("[data-amount]").attr("data-amount", d) : "0";
            updatePricing();
        });

        function checkDependantRequired() {
            switch(this.getAttribute("type")) {
                case "text":
                    if(this.value.length) {
                        $(this.dataset.notrequiredwhenvalue).closest(".input-container").removeAttr("required");
                    } else {
                        $(this.dataset.notrequiredwhenvalue).closest(".input-container").attr("required", "");
                    }
                    break;
                default:
                    break;
            }
        }
        $("[data-notrequiredwhenvalue]").on("input", checkDependantRequired);

        // return true when invalid
        var specialValidations = {
            "rufnummer": function(value) {
                const len = value.replace(/[^\d]/g, '').length;
                const isValidNumber = /^[+0][\d\s()/-]+$/.test(value.trim()) && len >= 8 && len <= 15;
                return Promise.resolve(!isValidNumber);
            },
            "vorwahl": function(value) {
                value = parseInt(value.trim().replace(/^0/, ""), 10);
                const vanityAreacodes = [700,15,16,17];
                return fetch("/wp-content/themes/amplus/assets/data/areacodes.json").then(response => response.json()).then(json => {
                    const isValidAreacode = json.includes(value) && !vanityAreacodes.includes(value);
                    return Promise.resolve(!isValidAreacode);
                }, error => {
                    // don't hinder entry when validation cannot succeed due to eg. malformed JSON
                    return Promise.resolve(false);
                });
            },
            "rufnummerohnevorwahl": function(value) {
                const len = value.replace(/[^\d]/g, '').length;
                const isValidNumber = /^[^+0][\d\s()/-]+$/.test(value.trim()) && len <= 11;
                return Promise.resolve(!isValidNumber);
            },
            "durchwahl": function(value) {
                const isValidNumber = /[0-9]+/.test(value.trim());
                return Promise.resolve(!isValidNumber);
            },
            "durchwahl-von": function(value) {
                const isValidNumber = /[0-9]+/.test(value.trim());
                const isLower = parseFloat(value) <= parseFloat($('[data-validate="durchwahl-bis"]').val());
                return Promise.resolve(!isValidNumber || !isLower);
            },
            "durchwahl-bis": function(value) {
                const isValidNumber = /[0-9]+/.test(value.trim());
                const isUpper = parseFloat(value) >= parseFloat($('[data-validate="durchwahl-von"]').val());
                return Promise.resolve(!isValidNumber || !isUpper);
            }
        };

        // returns true when invalid
        function validate($parentContainer, withoutVisualCue) {
            var promises = [];
            $parentContainer.find("[required]").each(function() {
                promises.push(new Promise((resolve, reject) => {
                    var notes = [];         // = all fail conditions, all notes should be prefix-free from one another
                    var input = $(this).find("input:not([type=radio])");
                    input = input.length ? input[0] : this;
                    var $input = $(input);
                    if($input.parents(".dependent.shown").length === $input.parents(".dependent").length && $input.closest(".deactivated").length === 0 && $input.closest("[disregard]").length === 0) {
                        var conditionForMissing = false;
                        if(specialValidations.hasOwnProperty(input.dataset.validate)) {
                            notes.push(specialValidations[input.dataset.validate](input.value).then(hasError => {
                                if(hasError) {
                                    return Promise.resolve("mismatch");
                                } else {
                                    return Promise.resolve("");
                                }
                            }));
                        }
                        switch(input.getAttribute("type")) {
                            case "email":
                                if(input.dataset.confirm !== "none") {
                                    conditionForMissing = $('input[name="' + input.name + 'confirm"]').closest(".input-container").hasClass("failure");
                                }
                                if(conditionForMissing) {
                                    notes.push(Promise.resolve("notequal"));
                                } else {
                                    conditionForMissing = input.value.length < 1;
                                }
                                break;
                            case "text":
                            case "date":
                                conditionForMissing = input.value.length < 1;
                                if(this.closest(".input-container")?.dataset.note?.includes("tooyoung")) {
                                    notes.push(Promise.resolve("tooyoung"));
                                }
                                else if(this.closest(".input-container")?.dataset.note?.includes("tooold")) {
                                    notes.push(Promise.resolve("tooold"));
                                }
                                if(input.validity.patternMismatch) {
                                    notes.push(Promise.resolve("mismatch"));
                                }
                                break;
                            case "number":
                                conditionForMissing = input.value === "";
                                break;
                            case "dropdown":
                                conditionForMissing = $(input).val().length < 1;     // JS is not getting attribute value of element not being input when not assigned by JS although it has default value
                                break;
                            case "checkbox":
                                conditionForMissing = !input.checked;
                                break;
                            case "radios":
                                conditionForMissing = $(input).find(":checked").length < 1;
                                break;
                            case "rates":
                                conditionForMissing = $(input).find("[chosenone]").length < 1;
                                break;
                            default:
                                break;
                        }
                        if(conditionForMissing) {
                            notes.push(Promise.resolve("missing"));
                        } else {
                            notes.push(Promise.resolve(""));
                        }
                    }
                    resolve(Promise.all(notes).then(notes => {
                        notes = notes.filter(resolvedValue => resolvedValue.length);
                        this.removeAttribute("data-note");       // reset to a clean state
                        if(notes.length > 0) {
                            if(!withoutVisualCue) {
                                this.setAttribute("data-note", notes.join(" "));
                            }
                            switch(input.getAttribute("type")) {
                                case "email":
                                case "text":
                                case "date":
                                case "number":
                                case "checkbox":
                                    $(input).attr("aria-invalid", "true");
                                    break;
                                case "radios":
                                case "dropdown":
                                    $(this).attr("aria-invalid", "true");
                                    break;
                                default:
                                    break;
                            }
                        } else {
                            switch(input.getAttribute("type")) {
                                case "email":
                                case "text":
                                case "date":
                                case "number":
                                case "checkbox":
                                    $(input).attr("aria-invalid", "false");
                                    break;
                                case "radios":
                                case "dropdown":
                                    $(this).attr("aria-invalid", "false");
                                    break;
                                default:
                                    break;
                            }
                        }
                        return Promise.resolve(notes.length > 0);
                    }));
                }));
            });
            return Promise.all(promises).then(promises =>  {
                var failed = false;
                $parentContainer.find("[must-success]").each(function() {
                    if(this.getAttribute("success") === null) {
                        failed = true;
                        if(!withoutVisualCue) {
                            setNote(this, "missing", true);
                        }
                    } else {
                        setNote(this, "missing", false);
                    }
                });
                return failed || promises.filter(hasNotes => hasNotes).length > 0;
            });
        }

        var step3Values;

        // transfer step 2 (and 1) data to step 3
        function onBeforeShowStep3() {
            hide($(".step3-summary .hide-until-shown"));
            hide($step3OverviewProducts.find(".hide-until-shown"));
            $("#Produktinformationsblatt").attr("href", document.body.dataset.isregio !== "true" ? $('.js-rate[chosenone]').data('datasrc') : $('.js-rate[chosenone]').data('datasrcregio'));
            // activate detailed costs summary section of step 3 according to set options from step 1
            var routerAId = $("[name=cost]:checked").closest("[data-articleid]").data("articleid");
            show($('[data-pid="' + routerAId + '"]'));
            show($step3OverviewProducts.find('[data-pid="' + routerAId + '"]'));
            if(orderProcessType === "b2b") {
                show($('[data-pid="runtime"]'));
                show($step3OverviewProducts.find('[data-pid="runtime"]'));
            }
            var installationAId = $("[name=installation]:checked").closest("[data-articleid]").data("articleid");
            show($('[data-pid="' + installationAId + '"]'));
            show($step3OverviewProducts.find('[data-pid="' + installationAId + '"]'));
            if($("[name=ipv4]:checked").length) {
                show($('[data-pid="ipv4"]'));
                show($step3OverviewProducts.find('[data-pid="ipv4"]'));
            }
            var atleastone = false;
            $("[name=mobile1]:checked,[name=mobile2]:checked,[name=mobile3]:checked").each(function() {
                var bookAId = $(this).closest("[data-articleid]").data("articleid");
                show($('[data-pid="' + bookAId + '"]'));
                show($step3OverviewProducts.find('[data-pid="' + bookAId + '"]'));
                atleastone = true;
            });
            if(atleastone) {
                showIgnoreSubs($('[data-pid="mobile-selected"]'));
                showIgnoreSubs($step3OverviewProducts.find('[data-pid="mobile-selected"]'));
            }
            atleastone = false;
            $("#anlagenanschluss:checked, [name=zusatzsprachkanaele]:checked, [name=weiteredurchwahlnummern]:checked").each(function() {
                var bookAId = $(this).closest("[data-articleid]").data("articleid");
                show($('[data-pid="' + bookAId + '"]'));
                show($step3OverviewProducts.find('[data-pid="' + bookAId + '"]'));
                atleastone = true;
            });
            if(atleastone) {
                showIgnoreSubs($('[data-pid="phone-features-selected"]'));
                showIgnoreSubs($step3OverviewProducts.find('[data-pid="phone-features-selected"]'));
            }
            atleastone = false;
            $('[name=mobileflatbusiness]:checked, [name="international-flat-1business"]:checked, [name="international-flat-2business"]:checked').each(function() {
                var bookAId = $(this).closest("[data-articleid]").data("articleid");
                show($('[data-pid="' + bookAId + '"]'));
                show($step3OverviewProducts.find('[data-pid="' + bookAId + '"]'));
                atleastone = true;
            });
            if(atleastone) {
                showIgnoreSubs($('[data-pid="phone-flats-selected"]'));
                showIgnoreSubs($step3OverviewProducts.find('[data-pid="phone-flats-selected"]'));
            }
            atleastone = false;
            [
                'fun_mobile_app', 'fun_settop_box', 'fun_hd', 'fun_lang_polish', 'fun_lang_russian', 'fun_lang_turkish', 'fun_lang_portuguese', 'fun_lang_spanish', 'regio_fun_mobile_app', 'regio_fun_settop_box'
            ].forEach(function(fun) {
                if($('[name="' + fun + '"]:checked').length) {
                    show($('[data-pid="' + fun + '"]'));
                    show($step3OverviewProducts.find('[data-pid="' + fun + '"]'));
                    atleastone = true;
                }
            });
            if(atleastone) {
                showIgnoreSubs($('[data-pid="fun-selected"]'));
                showIgnoreSubs($step3OverviewProducts.find('[data-pid="fun-selected"]'));
            }
            
            var $furtherPortphones = $("#furtherPortphones");
            $furtherPortphones.empty();
            var $furtherPortphonesJQ = $step3Overview.find("#furtherPortphones");
            $furtherPortphonesJQ.empty();
            var portPhoneSummaryTemplate = document.getElementById("summaryFurtherPortphone").content;
            var portPhoneSummaryTemplateJQ = $step3Overview.find("#summaryFurtherPortphone").get(0).content;
            document.querySelectorAll("#furtherPhonestoport .furtherphonetport").forEach((fptp, index) => {
                var portClone = portPhoneSummaryTemplate.cloneNode(true);
                var portCloneJQ = portPhoneSummaryTemplateJQ.cloneNode(true);
                var eId = portClone.querySelector("[data-id]");
                var eIdJQ = portCloneJQ.querySelector("[data-id]");
                eId.setAttribute("data-id", eId.dataset.id + "-" + (index + 2));
                eIdJQ.setAttribute("data-id", eIdJQ.dataset.id + "-" + (index + 2));
                portClone.querySelector(".summaryPhoneNumber").innerText = "" + (index + 2);
                portCloneJQ.querySelector(".summaryPhoneNumber").innerText = "" + (index + 2);
                $furtherPortphones[0].appendChild(portClone);
                $furtherPortphonesJQ[0].appendChild(portCloneJQ);
            });

            step3Values = {};

            // set personal data
            function transferData() {
                var destination = this;
                destination.innerHTML = "";
                $('[name="' + this.dataset.id + '"]').each(function() {
                    var source = $(this);
                    var parentsConditional = source.parents(".dependent");
                    if(parentsConditional.length === parentsConditional.filter(".shown").length && source.parents(".deactivated").length === 0) {
                        var value = "";
                        switch(source.attr("type")) {
                            case "text":
                                value = source.val();
                                break;
                            case "email":
                                value = source.val();
                                break;
                            case "number":
                                value = parseFloat(source.val());
                                break;
                            case "date":
                                var original = source.val();
                                if(typeof original === "string") {
                                    value = original.substr(8,2) + "." + original.substr(5,2) + "." + original.substr(0,4);
                                }
                                break;
                            case "checkbox":
                                if (source.is(":checked")){
                                    var original = source.val();
                                } else {
                                    var original = source.attr("notchecked");
                                }
                                if(typeof original === "string") {
                                    value = original.replace("&#39;", "'");
                                }
                                break;
                            case "radio":
                                source = source.closest('[type="radios"]').find('[type="radio"]').filter(":checked");
                                var val = source.val();
                                if(typeof val === "string") {
                                    value = val.replace("&#39;", "'");
                                }
                                break;
                            case "dropdown":
                                destination.dataset.code = source.val();
                                value = source.find(".js-dropdown-display").text();
                                break;
                            case "hidden":
                                value = source.val();
                                break;
                            default:
                                break;
                        }
                        switch (source.data("intrinsictypefromto")) {
                            case "dateiso2de":
                                value = value.substr(8,2) + "." + value.substr(5,2) + "." + value.substr(0,4);
                                break;
                            default:
                                break;
                        }
                        step3Values[destination.dataset.id] = value;
                        destination.innerHTML = value;
                        return false;
                    }
                });
            }
            function checkData() {
                var destination = this;
                $('[name="' + this.dataset.has + '"]').each(function() {
                    var source = $(this);
                    var parentsConditional = source.parents(".dependent");
                    if(parentsConditional.length === parentsConditional.filter(".shown").length && source.parents(".deactivated").length === 0) {
                        var hasData;
                        switch(source.attr("type")) {
                            case "date":
                                hasData = source.val().match(/\d\d\d\d-\d\d-\d\d/);
                                break;
                            case "checkbox":
                                hasData = source.is(":checked");
                                break;
                            case "radio":
                                hasData = source.closest('[type="radios"]').find('[type="radio"]').filter(":checked").length > 0;
                                break;
                            default:
                                hasData = source.val() !== "";
                                break;
                        }
                        if(hasData) {
                            destination.classList.remove("deactivated");
                        } else {
                            destination.classList.add("deactivated");
                        }
                    } else {
                        destination.classList.add("deactivated");
                    }
                });
            }
            $("[data-id]").each(transferData);
            $step3Overview.find("[data-id]").each(transferData);
            $("[data-has]").each(checkData);
            $step3Overview.find("[data-has]").each(checkData);

            var productData = updatePricing(true);
            function stringToBase64(string) {
                var result = "";
                try {
                    result = btoa(Array.from(new TextEncoder().encode(string), (byte) =>
                        String.fromCodePoint(byte),
                    ).join("")).replace(/\+/g, "-").replace(/\//g, "_");
                } catch(e) {}
                return result;
            }
            $("#contractSummary").attr("href", "/wp-json/leo/v1/checkout/pdf/" + encodeURIComponent(productData.rate) + "/" + encodeURIComponent(productData.router) + "/" + stringToBase64(JSON.stringify(productData.products)) + "/" + stringToBase64(productData.customer_name) + "/LEONET-Vertragszusammenfassung");

            function rebateDisplay() {
                if(rebateValue.length || chosenRate.dataset.haspromotion !== "1") {
                    $('#rebateProse').text(lastPricingData.promotion?.public_title);
                    $step3Overview.find('#rebateProse').text(lastPricingData.promotion?.public_title);
                    $("#lineRentalRebate").text(lastPricingData.one_time_rebate ? " + Anschlusspreisrabatt (AGS)" : "");
                    $step3Overview.find("#lineRentalRebate").text(lastPricingData.one_time_rebate ? " + Anschlusspreisrabatt (AGS)" : "");
                    show($("#onRebate"));
                    show($step3Overview.find("#onRebate"));
                } else {
                    hide($("#onRebate"));
                    hide($step3Overview.find("#onRebate"));
                }
            }

            if(waitingForPricingData) {
                $("#loaderKeeper").addClass("toAStep").css({"display": "flex"});
                return new Promise((resolve, reject) => {
                    dependentOnPricingData.push(function() {
                        $("#loaderKeeper").css({"display": "none"}).removeClass("toAStep");
                        rebateDisplay();
                        resolve();
                    });
                });
            } else {
                rebateDisplay();
                return Promise.resolve();
            }
        }

        // return Promise
        var transitionFunctions = {
            "1": {},
            "2": {},
            "3": {
                "beforeShow": onBeforeShowStep3
            }
        };

        var step2NotYetVisited = true;
        var currentlyRequestedStep;

        function setStep(newStep) {
            function stepSetter() {
                var bearer = $("[data-currentstep]");
                bearer.attr("data-currentstep", "" + newStep);
                if(newStep > +bearer.eq(0).attr("data-maxstep")) {
                    bearer.eq(0).attr("data-maxstep", "" + newStep);
                    if(newStep === 2 && step2NotYetVisited) {
                        step2NotYetVisited = false;
                        track("begin_checkout");
                    }
                }
                scrollTo(0, 0);

                $(".ausbauphasen-kategorien > li").each(function () {
                    var step = +$(this).data("step");
                    var currentStep = +$("[data-currentstep]").attr("data-currentstep") || 1;
                    var maxStep = +$("[data-maxstep]").attr("data-maxstep") || currentStep;

                    $(this).attr({
                        "tabindex": (currentStep === 3 ? step <= 3 : step <= maxStep) ? "0" : "-1",
                        "aria-disabled": (currentStep === 3 ? step <= 3 : step <= maxStep) ? "false" : "true"
                    });

                    if (step === currentStep) {
                        $(this).attr("aria-current", "step").focus();
                    } else {
                        $(this).removeAttr("aria-current");
                    }
                });
            }
            currentlyRequestedStep = newStep;
            if(transitionFunctions["" + newStep]?.beforeShow) {
                transitionFunctions["" + newStep].beforeShow().then(() => {
                    if(newStep === currentlyRequestedStep) {
                        stepSetter();
                    }
                });
            } else {
                stepSetter();
            }
        }

        // next, back
        window.navigateSteps = function(source) {
            var bearer = $("[data-currentstep]");
            var $source = $(source);
            var direction = $source.data("type") === "next" ? 1 : -1;
            var step = $source.closest("[data-step]");     // validate
            validate(step, direction === -1).then(result => {
                if(result) {
                    bearer.eq(0).attr("data-maxstep", step.attr("data-step"));
                    if(direction > 0) {
                        scrollTo(0, $("[data-note]").first().offset().top - 30);     // first failure
                        return;
                    }
                }
                var newStep = +bearer.eq(0).attr("data-currentstep") + direction;
                history.pushState({handleAsStep: true}, "", baseHref+ "/" + step2urlMapping[newStep - 1]);
                setStep(newStep);
            });
        };

        addEventListener("popstate", function(event) {
            if(event.state && event.state.handleAsStep) {
                var url = location.href.split("/");
                url = url[url.length - 1];
                var newStep = step2urlMapping.indexOf(url) + 1;
                setStep(newStep);
            }
        });

        function evalGoto() {
            var step = this.dataset.step;
            var maxbearer = $("[data-maxstep]");
            if(+step <= +maxbearer.attr("data-maxstep")) {
                var currentbearer = $("[data-currentstep]");
                var currentStep = currentbearer.attr("data-currentstep");
                var stepContentContainer = $('main [data-step="' + currentStep + '"]');
                validate(stepContentContainer, +step < +currentStep + 1).then(result => {
                    if(result) {
                        maxbearer.attr("data-maxstep", currentStep);
                        if(+step > +currentStep) {
                            scrollTo(0, $("[data-note]").first().offset().top - 30);     // first failure
                            return;
                        }
                    }
                    history.pushState({handleAsStep: true}, "", baseHref+ "/" + step2urlMapping[+step - 1]);
                    setStep(+step);
                });
            }
        }

        $("#orderProcessProgress [data-step]").on("click", evalGoto).on("keydown", function(e) {
            if(e.key === "Enter") {
                this.click();
            }
        });

        $('[data-type="emailconfirm"]').each(function() {
            var $this = $(this);
            var $email = $('[name="' + $this.attr("name").replace("confirm", "") + '"]');
            var parentElement = this.parentElement;
            $this.on("input", function() {
                if($email.val() === this.value && this.value.length) {
                    parentElement.classList.add("success");
                    parentElement.classList.remove("failure");
                    $this.attr("aria-invalid", "false");
                } else if($email.val().indexOf(this.value) !== 0 && $email.val().length) {
                    parentElement.classList.add("failure");
                    parentElement.classList.remove("success");
                    $this.attr("aria-invalid", "true");
                } else {
                    parentElement.classList.remove("success");
                    parentElement.classList.remove("failure");
                    $this.attr("aria-invalid", "false");
                }
            }).on("change", function() {
                if($email.val() === this.value && this.value.length) {
                    parentElement.classList.add("success");
                    parentElement.classList.remove("failure");
                    $this.attr("aria-invalid", "false");
                } else {
                    if(this.value.length && $email.val().length) {
                        parentElement.classList.add("failure");
                        parentElement.classList.remove("success");
                        $this.attr("aria-invalid", "true");
                    } else {
                        parentElement.classList.remove("success");
                        parentElement.classList.remove("failure");
                        $this.attr("aria-invalid", "false");
                    }
                }
            });
        })

        $('[data-type="email"]:not([data-confirm="none"])').each(function() {
            var $this = $(this);
            var $emailconfirm = $('[name="' + $this.attr("name") + "confirm" + '"]');
            var $parent = $emailconfirm.parent();
            $this.on("input", function() {
                if(this.value === $emailconfirm.val() && this.value.length) {
                    $parent.addClass("success");
                    $parent.removeClass("failure");
                    $this.attr("aria-invalid", "false");
                } else if(this.value.indexOf($emailconfirm.val()) === 0 || $emailconfirm.val().indexOf(this.value) === 0) {
                    $parent.removeClass("failure");
                    $parent.removeClass("success");
                    $this.attr("aria-invalid", "false");
                } else {
                    $parent.addClass("failure");
                    $parent.removeClass("success");
                    $this.attr("aria-invalid", "true");
                }
            }).on("change", function() {
                if($emailconfirm.val() === this.value && this.value.length) {
                    $parent.addClass("success");
                    $parent.removeClass("failure");
                    $this.attr("aria-invalid", "false");
                } else {
                    if(this.value.length && $emailconfirm.val().length) {
                        $parent.addClass("failure");
                        $parent.removeClass("success");
                        $this.attr("aria-invalid", "true");
                    } else {
                        $parent.removeClass("success");
                        $parent.removeClass("failure");
                        $this.attr("aria-invalid", "false");
                    }
                }
            });
        });

        function reIndexPhonestoport() {
            document.querySelectorAll("#furtherPhonestoport .furtherphonetport").forEach((fptp, index) => {
                var input = fptp.querySelector("input");
                input.name = input.name.split("-")[0] + "-" + (index + 2);
                input.setAttribute("aria-errormessage", "missingPhone" + (index + 2));
                fptp.querySelector(".phonenumber-missing").id = "missingPhone" + (index + 2); 
                $(input).off("input", inform).on("input", inform);
                var text = "" + (index + 2) + ". ";
                text += (index > (orderProcessType === "b2c" ? 1 : 8) ? "kostenpflichtige Rufnummer (0,95€ / Monat)" : "Rufnummer");
                fptp.querySelector(".phonenumber-number").innerText = text;
            });
            updatePricing();
        }

        window.addPhonetoport = function () {
            document.getElementById("furtherPhonestoport").appendChild(document.getElementById("furtherPhonetoport").content.cloneNode(true));
            reIndexPhonestoport();
        };

        window.delPhonetoport = function(src) {
            $(src).closest(".furtherphonetport").remove();
            reIndexPhonestoport();
        };

        // phone combo autosuggest/dropdown
        //var $phonesServiceProviderSuchwort = $("#phonesServiceProviderSuchwort");
        var $phonesServiceProvider = $("#phonesServiceProvider");
        var $phonesServiceProviderDDC = $phonesServiceProvider.find(".js-dropdown-items-container");
        var $originalPhonesServiceProviderList = $phonesServiceProviderDDC.clone(true);
        RegExp.quote = function(str) {
            return str.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        };
        function createOrderedPhonesServiceProviderList(forSearchString) {
            var matchFromBeginning = [];
            var matchFromGroupBeginning = [];
            var matchAnywhere = [];
            $originalPhonesServiceProviderList.children().each(function() {
                var indexFirstMatch = this.dataset.find.toLowerCase().indexOf(forSearchString.toLowerCase());
                if(indexFirstMatch > -1) {
                    var entryCopy = this.cloneNode(true);
                    if(indexFirstMatch === 0) {
                        matchFromBeginning.push(entryCopy);
                    } else {
                        var charBeforeMatch = this.dataset.find.charAt(indexFirstMatch - 1);
                        if(charBeforeMatch === ' ' || charBeforeMatch === '-') {
                            matchFromGroupBeginning.push(entryCopy);
                        } else {
                            matchAnywhere.push(entryCopy);
                        }
                    }
                    var rE = new RegExp(RegExp.quote(forSearchString), "i");
                    var matchRE = entryCopy.innerHTML.match(rE);
                    entryCopy.innerHTML = entryCopy.innerHTML.replace(rE, "<span class='match-highlight'>" + (matchRE.length > 0 ? matchRE[0] : forSearchString) + "</span>");
                }
            });
            $phonesServiceProviderDDC.empty();
            matchFromBeginning.forEach(entry => {
                $phonesServiceProviderDDC.append(entry);
            });
            if(matchFromGroupBeginning.length > 0) {
                matchFromGroupBeginning[0].classList.add("first-of-group-phones-provider");
            }
            matchFromGroupBeginning.forEach(entry => {
                $phonesServiceProviderDDC.append(entry);
            });
            if(matchAnywhere.length > 0) {
                matchAnywhere[0].classList.add("first-of-group-phones-provider");
            }
            matchAnywhere.forEach(entry => {
                $phonesServiceProviderDDC.append(entry);
            });
            $phonesServiceProvider.find(".js-dropdown-item").on("click", window.selectDropdownItem);
        }
        var $phonesServiceProviderSuche = $('#phonesServiceProviderSuche').on("input", function() {
            $phonesServiceProviderSuche.attr("data-val", this.value);
            if(this.value.trim() === '') {
                $phonesServiceProviderDDC.empty();
                $phonesServiceProviderDDC.html($originalPhonesServiceProviderList.html());
                $phonesServiceProvider.find(".js-dropdown-item").on("click", window.selectDropdownItem);
            } else {
                createOrderedPhonesServiceProviderList(this.value.trim());
            }
            // simple match
            //$phonesServiceProviderSuchwort.text(this.value.trim() === '' ? '' : ('#phonesServiceProvider .dropdown-item:not([data-find*="' + this.value + '"i]){display:none}'));
            show($phonesServiceProviderDDC);
        }).on("focus", function() {
            if(this.value.trim() === '') {
                $phonesServiceProviderDDC.empty();
                $phonesServiceProviderDDC.html($originalPhonesServiceProviderList.html());
                $phonesServiceProvider.find(".js-dropdown-item").on("click", window.selectDropdownItem);
            } else {
                createOrderedPhonesServiceProviderList(this.value.trim());
            }
            // simple match
            //$phonesServiceProviderSuchwort.text(this.value.trim() === '' ? '' : ('#phonesServiceProvider .dropdown-item:not([data-find*="' + this.value + '"i]){display:none}'));
            setNote($phonesServiceProviderSuche.attr("aria-invalid", "false").closest(".input-container"), "missing", false);
            setTimeout(() => show($phonesServiceProviderDDC), 200);   // gets removed without timeout, unknown reason
        }).on("blur", () => {
            setTimeout(function () {
                var val = $phonesServiceProviderSuche.val().trim().toLowerCase();
                var found = false;
                $phonesServiceProvider.find("[data-find]").each(function() {
                    if(this.dataset.find.trim().toLowerCase() === val) {
                        this.click();
                        found = true;
                        return false;
                    }
                });
                if(!found) {
                    setNote($phonesServiceProviderSuche.attr("aria-invalid", "true").closest(".input-container"), "missing", true);
                }
            }, 200);    // wait for pickedup event to update value
        });
        $phonesServiceProvider.on("pickedup", function(event, data, text) {
            setNote($phonesServiceProviderSuche.val(text).attr("data-val", data.replace("'", "&#39;")).attr("aria-invalid", "false").closest(".input-container"), "missing", false);
        });


        // IBAN validation
        window.validateIBAN = function (input) {
            function mod97(string) {
                var checksum = string.slice(0, 2), fragment;
                for (var offset = 2; offset < string.length; offset += 7) {
                    fragment = String(checksum) + string.substring(offset, offset + 7);
                    checksum = parseInt(fragment, 10) % 97;
                }
                return checksum;
            }

            var CODE_LENGTHS = {
                AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
                CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
                FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
                HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
                LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
                MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
                RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,   
                AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
                SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
            };

            var iban = String(input.value).toUpperCase().replace(/[^A-Z0-9]/g, ''),             // keep only alphanumeric characters
                code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);                             // match and capture (1) the country code, (2) the check digits, and (3) the rest

            var inputContainer = input.closest(".input-container");
            if(code && iban.length === CODE_LENGTHS[code[1]] && mod97((code[3] + code[1] + code[2]).replace(/[A-Z]/g, function(letter) {return letter.charCodeAt(0) - 55})) === 1) {    // rearrange country code, check digits, convert chars to ints
                inputContainer?.setAttribute("success", "");
                setNote(inputContainer, "missing", false);
            } else {
                inputContainer?.removeAttribute("success", "");
                setNote(inputContainer, "missing", true);
            }
        };

        // submit order
        window.submitForm = function(source) {
            validate($(source).closest("[data-step]")).then(result => {
                if(result) {
                    scrollTo(0, $("[data-note][required]").first().offset().top - 30);     // first failure
                } else {
                    $("#loaderKeeper").css({"display": "flex"});
                    var ph = $("<div>" + $step3Overview.html() + "</div>");
                    ph.find(".dependent:not(.shown), .dependent.deactivated").remove();
                    ph.find("#summaryFurtherPortphone").remove();
                    ph.find("#newsletterConfirmation").empty();
                    ph.find(".deactivated[data-has]").remove();
                    if($("#check31").is(":checked")) {
                        ph.find("#newsletterConfirmation").html("<br><br>" + $step3NewsletterConfirmation + "<br><br>");
                    }
                    var ch = $("<div>" + $step3OverviewProducts.html() + "</div>");
                    ch.find(".hide-until-shown:not(.shown)").remove();
                    if(document.body.dataset.isregio !== "true") {
                        ph.find(".toni-only-after").remove();
                        ch.find(".toni-only-after").remove();
                    }
                    var pricing = updatePricing(true);
                    var tosend = {
                        personal: {},
                        rate: pricing.rate,
                        router: pricing.router,
                        products: pricing.products,
                        rebate: rebateValue,
                        "transaction-id": uuid,
                        "order-html": "<div>" + ph.html() + "</div>",
                        "products-html": "<div>" + ch.html() + "</div>",
                        "validation-code": document.body.dataset.key,
                        "ad-consent": $("#check31").prop("checked"),
                        "foreign_id": sessionStorage.getItem("foreignid")
                    };
                    for (var id in step3Values) {
                        tosend.personal[id] = step3Values[id];
                        var code = $('[data-id="' + id + '"]').data("code");
                        typeof code !== "undefined" ? tosend.personal[id + "_code"] = (code + "").replace("&#39;", "'") : 0;
                        var $src = $("#" + id);
                        if($src.data("usedata")) {
                            tosend.personal[id] = $src.data("val");
                        }
                    }
                    if($('input[name="locationtype"]:checked').val() !== "Mehrparteiengebäude") {
                        tosend.personal["location-living-units"] = $('input[name="locationtype"]:checked').parent().index() + 1;
                    }
                    var countExtraPortphones = document.querySelectorAll("#furtherPhonestoport .furtherphonetport").length;
                    if(orderProcessType === "b2c") {
                        if($("#radio-portphone").is(":checked") && !$("#anlagenanschluss").is(":checked")) {
                            countExtraPortphones -= 2;
                            tosend.personal["freephonenumbers_code"] = 3 + ((countExtraPortphones < 0) ? countExtraPortphones : 0);
                            tosend.personal["paidphonenumbers_code"] = (countExtraPortphones > 0) ? countExtraPortphones : 0;
                        }
                        tosend.products["paid-phone-number"] = parseInt("0" + $("#paidphonenumbers").val(), 10);       // default val can be no number, parse 0 + results in 0 then
                    } else {
                        if($("#radio-portphone").is(":checked") && !$("#anlagenanschluss").is(":checked")) {
                            countExtraPortphones -= 9;
                            tosend.personal["freephonenumbers_code"] = 10 + ((countExtraPortphones < 0) ? countExtraPortphones : 0);
                            tosend.personal["paidphonenumbers_code"] = (countExtraPortphones > 0) ? countExtraPortphones : 0;
                        }
                        tosend.products["paid-phone-number"] = 0;
                    }
                    var tracking = sessionStorage.getItem("trackingQuery");
                    if(tracking) {
                        tosend["tracking"] = JSON.parse(tracking);
                    }
                    if(sessionStorage.getItem("landingUGGAdform") === "1") {
                        const nameMap = {
                            "b2c150": "Leonet_150",
                            "b2c300": "Leonet_300",
                            "b2c500": "Leonet_600",
                            "b2c1000": "Leonet_1000"
                        };
                        const orderedRate = document.querySelector('.js-rate[data-articleid="' + pricing.rate + '"]');
                        adf?.track({
                            HttpHost: 'track.adform.net',
                            pm: 4107112,
                            pagename: encodeURIComponent('Bestellstrecke'),
                            divider: encodeURIComponent('|'),
                            order: { 
                                sales: orderedRate.dataset.defaultprice.replace(',','.'),
                                orderid: uuid,
                                itms: [{ 
                                    productid: nameMap[pricing.rate],
                                    productname: orderedRate.dataset.articlename,
                                    productsales: orderedRate.dataset.promotionprice?.replace(',','.') || orderedRate.dataset.defaultprice.replace(',','.'),
                                    step: 3
                                }]
                            }
                        });
                    }
                    $.post({
                        url: "/wp-json/leo/v1/checkout/order",
                        data: JSON.stringify(tosend),
                        success: function(data) {
                            if(data.success === 1) {
                                track("purchase");
                                history.replaceState({}, "bestellt!", "/");
                                document.cookie = "promo=;path=/;Max-Age=0";
                                document.cookie = "promo-doa=;path=/;Max-Age=0";
                                clearSession(true);
                                sessionStorage.setItem("Anrede", $('[name="personal-anrede"]').find(".js-dropdown-display").text());
                                sessionStorage.setItem("Name", $('[name="personal-surname"]').val());
                                sessionStorage.setItem("orderedRate", tosend.rate);
                                location.href = data.thankyoupage;
                            } else {
                                $("#loaderKeeper").css({"display": "none"});
                                if(confirm("Es ist ein Fehler aufgetreten, bitte versuchen Sie es noch mal.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen.\n\ncode: " + data.code + "\nmessage: " + data.message)) {
                                    location.href = "#Kontakt";
                                }
                            }
                        },
                        error: function(e) {
                            var code = "";
                            var message = "";
                            try {
                                code = e.responseJSON.code;
                                message = e.responseJSON.message;
                            } catch(e) {}
                            $("#loaderKeeper").css({"display": "none"});
                            if(confirm("Es ist ein Fehler aufgetreten, bitte versuchen Sie es noch mal.\n\nSollte der Fehler erneut auftreten kontaktieren Sie bitte unseren Support.\n\nKlicken Sie OK, um Kontaktmöglichkeiten anzuzeigen.\n\ncode: " + code + "\nmessage: " + message)) {
                                location.href = "#Kontakt";
                            }
                        }
                    });
                }
            });
        };

    });
})(jQuery);
